import type { IControlSettingData } from '~/presentation/reports/common/type';

import { EDimensionKey, EReportControlId } from '~/presentation/reports/common/type';
import { OPERATOR_IS, OPERATOR_IS_ONE_OF } from '../constants';
import { CHART_OPTIONS } from '~/presentation/reports/common';
import { AnalyticInterval } from '~/modules/analytics/types';
import { DEFAULT_DIMENSIONS } from './default-ui';

export const DEFAULT_FILTER_PRESET: IControlSettingData = {
  [EReportControlId.CHART]: {
    value: CHART_OPTIONS[0].value,
  },
  [EReportControlId.DIMENSIONS_FILTER]: {
    value: DEFAULT_DIMENSIONS,
  },
  [EDimensionKey.TIME]: {
    value: AnalyticInterval.DAY.toLocaleLowerCase(),
  },
  [EReportControlId.VERSION_OPERATOR]: {
    value: OPERATOR_IS,
  },
  [EReportControlId.TRAFFIC_SOURCE_OPERATOR]: {
    value: OPERATOR_IS,
  },
  [EReportControlId.VISITOR_OPERATOR]: {
    value: OPERATOR_IS,
  },
  [EReportControlId.DEVICE_OPERATOR]: {
    value: OPERATOR_IS,
  },
  [EReportControlId.CAMPAIGN_ITEM_OPERATOR]: {
    value: OPERATOR_IS_ONE_OF,
  },
  [EReportControlId.PAGE_OPERATOR]: {
    value: OPERATOR_IS,
  },
  [EReportControlId.GROUP_CAMPAIGN_ITEM]: {
    value: undefined,
  },

  [EReportControlId.SINGLE_CAMPAIGN]: {
    value: undefined,
  },
  [EReportControlId.GROUP_CAMPAIGN]: {
    value: undefined,
  },
  [EReportControlId.PRICE_CAMPAIGN]: {
    value: undefined,
  },
  [EReportControlId.URL_CAMPAIGN]: {
    value: undefined,
  },
};
